<template>
  <div id="app">
    <navigation :visible="hasNav" />
    <div class="app__wrapper">
      <main v-if="hasLayout"
            class="app__main app__main--with-layout"
            :class="{ 'app__main--with-nav': hasNav }">
        <div class="uk-container app__container" v-if="isAuthenticated">
          <breadcrumbs />
          <router-view />
        </div>
        <div v-else class="app__container--loading uk-text-center uk-margin-medium-top">
          <loader />
        </div>
      </main>
      <main v-else class="app__main" :class="{ 'app__main--with-nav': hasNav }">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Authentication from '@/mixins/Authentication';
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import Navigation from '@/components/Navigation';
import ProgressBar from 'nprogress';

export default {
  name: 'app',
  mixins: [Authentication],
  components: {
    Breadcrumbs,
    Loader,
    Navigation,
  },
  watch: {
    isLoaded(loaded) {
      if (loaded) {
        ProgressBar.done();
      } else {
        ProgressBar.start();
      }
    },
  },
  computed: {
    hasLayout() {
      const layout = this.$route.meta.layout;
      return typeof layout === 'undefined' || layout;
    },
    hasNav() {
      return this.isAuthenticated && this.hasLayout;
    },
    ...mapGetters(['loading', 'isLoaded', 'isLoading']),
  },
};
</script>

<style lang="scss" scoped>
@import '../theme/variables.scss';

.app__main {
  transition: margin 250ms ease-out;
}

.app__main--with-layout {
  margin: $global-medium-gutter 0;
}

.app__main--with-layout.app__main--with-nav {
  margin-left: $primary-nav-width;
}
</style>



// WEBPACK FOOTER //
// App.vue?78550dc2